import hostyAppIcon from '@assets/images/hosty-app-icon.png';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useErpAuth } from '../../context/ErpAuthContext';
import { usePanelMenu } from '../../hooks/usePanelMenu';
import { Button } from '../ui/Button';
import { PanelMobileHeader } from './PanelMobileHeader';
import './layouts.css';
import '../../pages/erp/erp.css';

const navItems = [
  { to: '/erp', label: 'Resumen', end: true },
  { to: '/erp/clientes', label: 'Clientes' },
  { to: '/erp/clientes/nuevo', label: 'Nuevo cliente' },
  { to: '/erp/verifactu', label: 'Verifactu' },
  { to: '/erp/agentes', label: 'Agentes' },
  { to: '/erp/pagos', label: 'Liquidaciones' },
  { to: '/erp/cobros', label: 'Cobros y costes' },
  { to: '/erp/versiones', label: 'Versiones TPV' },
  { to: '/erp/descargas', label: 'Descargas' },
  { to: '/erp/agentes/nuevo', label: 'Nuevo agente' },
];

export function ErpLayout() {
  const { user, logout } = useErpAuth();
  const navigate = useNavigate();
  const { open, toggle, close } = usePanelMenu();

  async function handleLogout() {
    await logout();
    navigate('/erp/login');
  }

  const brand = (
    <Link to="/" className="brand brand--panel">
      <img src={hostyAppIcon} alt="" className="brand__mark" width={32} height={32} />
      <span>
        Hosty <strong>ERP</strong>
      </span>
    </Link>
  );

  return (
    <div className="erp-layout">
      <PanelMobileHeader brand={brand} open={open} onToggle={toggle} />
      <button
        type="button"
        className={`panel-menu-overlay ${open ? 'is-open' : ''}`}
        aria-label="Cerrar menú"
        onClick={close}
        tabIndex={open ? 0 : -1}
      />
      <aside className={`erp-sidebar ${open ? 'is-open' : ''}`}>
        {brand}
        <nav className="erp-nav">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className="erp-nav__link">
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="panel-sidebar__footer">
          <div className="panel-user">
            <strong>
              {user?.name} {user?.surname}
            </strong>
            <span>{user?.email}</span>
          </div>
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            Cerrar sesión
          </Button>
        </div>
      </aside>
      <main className="erp-main">
        <Outlet />
      </main>
    </div>
  );
}
